import Button from "react-bootstrap/Button";
import React, {Alert, Collapse, ListGroup, ListGroupItem, Stack} from "react-bootstrap";
import Container from "react-bootstrap/Container";
import {useState} from "react";
import {ReactComponent as ExpandIcon} from "../../../assets/images/icons/chevron-up-svgrepo-com.svg";
import {ReactComponent as CollapseIcon} from "../../../assets/images/icons/chevron-down-svgrepo-com.svg";

export const ImportantNotes = () => {
    const [notesOpen, setNotesOpen] = useState(true);


    return (
        <Container className="bg-success mb-3 p-3 rounded-3 d-flex flex-column column-gap-1 row-gap-1">
            <Alert
                className="bg-primary-subtle align-items-center text-black text-center mb-0 d-flex"
                onClick={() => setNotesOpen(!notesOpen)}
                aria-controls="notes-collapse-text"
                aria-expanded={notesOpen}
            >
                        <span className="flex-grow-1">
                            Before you begin, please review our terms
                        </span>
                {notesOpen
                    ? <CollapseIcon fill="black" className="mx-2"
                                    style={{height: "20px", width: "20px", minWidth: "20px"}}/>
                    : <ExpandIcon fill="black" className="mx-2"
                                  style={{height: "20px", width: "20px", minWidth: "20px"}}/>
                }

            </Alert>
            <Collapse in={notesOpen} className={""}>
                <ListGroup aria-label="Booking quick facts">
                    <ListGroupItem>
                        <strong>Rate and pricing:</strong> Custom tattoos: $200/hr ; Flash: Priced per design
                    </ListGroupItem>
                    <ListGroupItem>
                        <strong>Duration estimates:</strong> Provided durations for Custom tattoos are estimates. Final cost based on actual hours worked.
                    </ListGroupItem>
                    <ListGroupItem>
                        <strong>Deposit:</strong> $100 (Custom & Flash; applied to final cost)
                    </ListGroupItem>
                    <ListGroupItem>
                        <strong>Deposit expiry:</strong> forfeited after 1 year if not completed
                    </ListGroupItem>
                    <ListGroupItem>
                        <strong>Rescheduling window:</strong> up to 72 hours before appointment
                    </ListGroupItem>
                    <ListGroupItem>
                        <strong>Touch-ups:</strong> Tattoos by Erika: Free. Other artists’
                        work: from $50 (size dependent).
                    </ListGroupItem>
                </ListGroup>
            </Collapse>
        </Container>
    );
}


// <ListGroupItem>
//     <strong>Non-Refundable Deposit:</strong>
//     A $100 non-refundable deposit is required at the time of booking for all new tattoo appointments.
//     The deposit amount will be deducted from the total cost of your tattoo at the end of your appointment.
// </ListGroupItem>
// <ListGroupItem>
//     <strong>Rescheduling Flexibilty:</strong>
//     Life happens! You are welcome to reschedule for a later date any time, up to 72 hours before your appointment.
//     Rescheduling is handled through the link to your appointment included in the confirmation email sent
//     after booking.
// </ListGroupItem>
// <ListGroupItem>
//     <strong>Deposit Expiration:</strong> Unfortunately, we cannot hold on to your
//     deposit indefinitely. If your appointment does not occur within one year of the original booking,
//     the deposit will be considered forfeit.
// </ListGroupItem>
// <ListGroupItem>
//     <strong>Touch-ups:</strong>
//     I will touch up any tattoo done by me in the past free of charge.
// </ListGroupItem>